exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_status[data-v-45da890f]{border-radius:5px 5px 0 0;font-size:16px;padding-left:16px;padding-top:12px;padding-bottom:12px;text-align:center}.btn_status[data-v-45da890f]:hover{background-color:#f1f2f7}", ""]);

// exports
